"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityStackBadge = exports.EntityStackBadgeDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var person_photo_1 = require("./person-photo");
var use_lang_1 = require("../../hooks/use-lang");
var sprintf_js_1 = require("sprintf-js");
var badge_1 = require("../elements/badge");
exports.EntityStackBadgeDefaultProps = {
  items: [],
  maxPhotos: 3,
  photoSize: 24,
  overlap: 8,
  suffixLabel: '',
  singleLabel: 'Follower',
  multipleLabel: 'Followers',
  hasBadge: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    font-size: 1em;\n  "], ["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    font-size: 1em;\n  "])))
});
var PhotosStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    list-style: none;\n    margin: 0;\n    padding: 0 ", " 0 0;\n    display: flex;\n    align-items: center;\n    ", "\n  "], ["\n    list-style: none;\n    margin: 0;\n    padding: 0 ", " 0 0;\n    display: flex;\n    align-items: center;\n    ", "\n  "])), theme_1.theme.UNIT(2), function (_a) {
    var overlap = _a.overlap;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-right: ", "px;\n    "], ["\n      margin-right: ", "px;\n    "])), overlap);
  })
});
var PhotoItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    ", "\n  "], ["\n    margin: 0;\n    padding: 0;\n    ", "\n  "])), function (_a) {
    var overlap = _a.overlap;
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-right: -", "px;\n    "], ["\n      margin-right: -", "px;\n    "])), overlap);
  })
});
var PhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    order: 1;\n  "], ["\n    order: 1;\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    order: 2;\n    font-size: 1em;\n    white-space: nowrap;\n    margin: 0;\n    padding: 0;\n    font-weight: 400;\n\n    ", "\n  "], ["\n    order: 2;\n    font-size: 1em;\n    white-space: nowrap;\n    margin: 0;\n    padding: 0;\n    font-weight: 400;\n\n    ", "\n  "])), function (_a) {
    var hasPadding = _a.hasPadding;
    return hasPadding && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding-right: ", ";\n    "], ["\n      padding-right: ", ";\n    "])), theme_1.theme.UNIT(4));
  })
});
var BadgeDividerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    order: 3;\n    padding-left: ", ";\n    ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    order: 3;\n    padding-left: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4), theme_1.theme.DOT_BG('v', 'line-mid', 2, 4))
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Photos: styled_components_1.default.ul(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), PhotosStyles),
  PhotoItem: styled_components_1.default.li(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), PhotoItemStyles),
  Photo: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Label: styled_components_1.default.h5(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  BadgeDivider: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), BadgeDividerStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
var EntityStackBadge = function (props) {
  var className = props.className,
    _a = props.items,
    items = _a === void 0 ? [] : _a,
    maxPhotos = props.maxPhotos,
    photoSize = props.photoSize,
    overlap = props.overlap,
    singleLabel = props.singleLabel,
    multipleLabel = props.multipleLabel,
    suffixLabel = props.suffixLabel,
    badgeLabel = props.badgeLabel,
    hasBadge = props.hasBadge;
  var t = (0, use_lang_1.useLang)();
  var count = items.length;
  var label = (0, sprintf_js_1.sprintf)(count === 1 ? t("%s ".concat(singleLabel)) : count === 0 ? t("No Followers ".concat(suffixLabel)) : t("%s ".concat(multipleLabel, " ").concat(suffixLabel)), count);
  var limit = Math.min(count, maxPhotos);
  var itemsToShow = items.slice(0, limit);
  var hasPhotos = !!count;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(My.Label, {
    hasPadding: hasBadge
  }, label), hasPhotos && react_1.default.createElement(My.Photos, {
    overlap: overlap,
    count: itemsToShow.length
  }, itemsToShow.map(function (item) {
    return react_1.default.createElement(My.PhotoItem, {
      key: item.id,
      overlap: overlap
    }, react_1.default.createElement(My.Photo, {
      entity: item,
      border: true,
      size: photoSize
    }));
  }))), hasBadge && react_1.default.createElement(My.BadgeDivider, null, react_1.default.createElement(My.Badge, null, t(badgeLabel))));
};
exports.EntityStackBadge = EntityStackBadge;
exports.EntityStackBadge.defaultProps = exports.EntityStackBadgeDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;